export interface PowerChartOptions {
    showPower?: boolean;
    showPowerForEan?: string | null;
}

export function changePowerSelection(
    options: PowerChartOptions, showPower: boolean, ean: string | null, reloadMeasurements: () => void
): void {
    options.showPower = showPower;
    options.showPowerForEan = ean;
    reloadMeasurements();
}
